import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchMPArticle, clearMPArticle } from "store/mpArticleSlice";
import { Helmet } from "react-helmet-async";
import MPArticleView from "./MPArticleView";
import MPArticleSkeleton from "./MPArticleSkeleton";
import MPArticleError from "./MPArticleError";
import s from "./MPArticlePage.module.css";

const MPArticlePage = () => {
  const { code_mp } = useParams();
  const dispatch = useDispatch();
  const { html, loading, error } = useSelector((state) => state.mpArticle);

  useEffect(() => {
    if (code_mp) {
      dispatch(fetchMPArticle(code_mp));
    }

    return () => {
      dispatch(clearMPArticle());
    };
  }, [code_mp, dispatch]);

  // Извлекаем title из HTML если возможно
  const titleMatch = html?.match(/<title[^>]*>([^<]+)<\/title>/i);
  const pageTitle = titleMatch ? titleMatch[1] : `Статья МУ ${code_mp || ""}`;

  return (
    <div className={s.pageContainer}>
      <Helmet prioritizeSeoTags>
        <title>{pageTitle}</title>
      </Helmet>

      {loading && <MPArticleSkeleton />}
      {error && <MPArticleError error={error} codeMP={code_mp} />}
      {!loading && !error && html && <MPArticleView html={html} />}
      {!loading && !error && !html && (
        <MPArticleError error="Статья не найдена" codeMP={code_mp} />
      )}
    </div>
  );
};

export default MPArticlePage;
